import { gql } from "graphql-request";

export const LIST_PARAMETERS_QUERY = gql`
query listParameters($paramNames:[String],$paramService: String ) {
  listParameters(input: {paramNames: $paramNames, paramService: $paramService}) {
    message
    paramNames
    paramService
    paramValues
    statusCode
  }
}
`;